import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getMethod } from "../../store/actions";
import FilterWrapper from "../Filters/FilterWrapper";
import GridContainer from "../GridView/GridContainer";
import LiveMintsList from "./LiveMintsList";

const LiveMints = () => {
  const dispatch = useDispatch();
  const [gridView, setGridView] = useState(true);
  const { id } = useParams();

  const changeViewType = useCallback(
    (value) => {
      setGridView(value);
    },
    [gridView]
  );
  const [value, setValue] = useState("");
  const [data, setdata] = useState([]);

  useEffect(() => {
    dispatch(
      getMethod(
        `livemint`,
        { contract_address: id },
        process.env.REACT_APP_REQUEST_URL
      )
    )
      .then((res) => {
        setdata(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="tab-pane" id="tabs-4" role="tabpanel">
      <div className="chart-box bg-white pb-5">
        <FilterWrapper
          title={"Minted NFT’s"}
          viewType={gridView}
          changeViewType={changeViewType}
          view={true}
        />
        {gridView ? (
          <GridContainer list={data} />
        ) : (
          <LiveMintsList list={data} />
        )}
      </div>
    </div>
  );
};

export default LiveMints;
